import React from 'react';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import Button from 'commonComponents/Button/Button';
import TickIcon from 'oldAssets/images/icons/check-green.svg';
import styles from './Investment.module.scss';

const Investment = ({ header, subheader, data, button, link }) => {
  return ( 
    <section className={ styles.Investment }>
      <div className={ styles.content }>
        <PrimarySectionHeader
          header={ header }
          subheader={ subheader }
          anchor='investment'
        />
        <div className={ styles.data }>
          {data && data.map(item => <Item key={ item.title } { ...item } />)}
        </div>
        <Button label={ button } link={ link } />
      </div>
    </section>
  );
};

const Item = ({ title, text, def }) => {
  return ( 
    <div className={ styles.Item }>
      <figure className={ styles.tick }>
        <img src={ TickIcon } width="35" />
      </figure>
      <div className={ styles.text }>
        <h6>{ title } <span>{ def }</span></h6>
        <p>{ text }</p>
      </div>
    </div>
  );
};
 
export default Investment;